import React, { Component } from "react";
import styles from "./controlPoints.module.scss";
import { withLogisticControlPoints } from "../../../shared/containers/containerLogisticControlPoints";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Scrollbars from "react-custom-scrollbars-2";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import MiniMapControlPoint from "./MiniMapControlPoint";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { withAuth } from "../../../shared/containers/containerAuth";

class ControlPointsList extends Component {
  constructor(props) {
    super(props);

    this.state = { isDeleteModalOpen: false, deleteControlPoint: null, controlPointForMiniMap: null };
  }

  onDelete(controlPoint) {
    const { onDeleteControlPoint } = this.props;

    onDeleteControlPoint({ id: controlPoint.id });
  }

  onChangeClick(controlPoint) {
    const { onSelectControlPoint, onSetViewPanel, viewPanelItems } = this.props;

    onSelectControlPoint(controlPoint);
    onSetViewPanel(viewPanelItems.createControlPoint);
  }

  onSetControlPointForMiniMap(controlPoint) {
    this.setState({ controlPointForMiniMap: controlPoint });
  }

  render() {
    const { logisticControlPoints, logisticLastControlPoint, data } = this.props;
    const { isDeleteModalOpen, deleteControlPoint, controlPointForMiniMap } = this.state;

    const height = window.innerHeight > 800 ? 650 : 450;

    const сontrolPointsUpdatePermission = data.permissions.includes(26004);
    const controlPointsDeletePermission = data.permissions.includes(26003);
    const controlPointsCreatePermission = data.permissions.includes(26002);

    return (
      <div className={styles.controlPointsListContainer}>
        {controlPointForMiniMap !== null ? (
          <div className={styles.miniMapContainer}>
            <MiniMapControlPoint
              controlPoint={controlPointForMiniMap}
              onSetControlPointForMiniMap={this.onSetControlPointForMiniMap.bind(this)}
            />
          </div>
        ) : null}

        {controlPointsCreatePermission ? (
          <div className={styles.createToolsContainer}>
            <TooltipWrapper title={"Создать новую контрольную точку"} position="left">
              <ControlPointIcon
                className={styles.icon}
                fontSize="large"
                onClick={() => {
                  this.onChangeClick({
                    id: null,
                    title: null,
                    latitude: logisticLastControlPoint !== null ? logisticLastControlPoint.latitude : 53,
                    longitude: logisticLastControlPoint !== null ? logisticLastControlPoint.longitude : 27,
                    radius: logisticLastControlPoint !== null ? logisticLastControlPoint.radius : 15,
                    maxSpeed: logisticLastControlPoint !== null ? logisticLastControlPoint.maxSpeed : 2,
                    address: null,
                    geocoderAddress: null,
                    description: null,
                  });
                }}
              />
            </TooltipWrapper>
          </div>
        ) : null}

        <div className={styles.controlPointHeaderTable}>
          <div>Наименование</div>
          <div>Адрес</div>
          <div>Описание</div>
          <div></div>
        </div>

        <div className={styles.controlPointsListTable}>
          <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
            {logisticControlPoints.map((controlPoint, index) => {
              return (
                <div
                  key={controlPoint.id}
                  className={styles.controlPointItemTable}
                  style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
                  onClick={(e) => {}}
                >
                  <div>{controlPoint.title}</div>
                  <div>{controlPoint.address}</div>
                  <div>{controlPoint.description}</div>
                  <div className={styles.controlPointItemToolpanel}>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onSetControlPointForMiniMap(controlPoint);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <TooltipWrapper title={`Просмотреть контрольную точку ${controlPoint.title}`} position="top">
                        <VisibilityIcon fontSize="small" />
                      </TooltipWrapper>
                    </div>

                    {сontrolPointsUpdatePermission ? (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          this.onChangeClick(controlPoint);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {}
                        <TooltipWrapper title={`Посмотреть или изменить контрольную точку: ${controlPoint.title}`} position="top">
                          <EditIcon fontSize="small" />
                        </TooltipWrapper>
                      </div>
                    ) : (
                      <div></div>
                    )}

                    {controlPointsDeletePermission ? (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({ isDeleteModalOpen: true, deleteControlPoint: controlPoint });
                        }}
                        style={{ width: "50px", cursor: "pointer" }}
                      >
                        <TooltipWrapper title={`Удалить контрольную точку ${controlPoint.title}`} position="top">
                          <DeleteIcon fontSize="small" />
                        </TooltipWrapper>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              );
            })}
          </Scrollbars>
        </div>

        {deleteControlPoint !== null ? (
          <ModalConfirmWindow isOpen={isDeleteModalOpen}>
            <DeleteConfirm
              onConfirmHandle={() => {
                this.onDelete(deleteControlPoint);
                this.setState({ isDeleteModalOpen: false, deleteControlPoint: null });
              }}
              onNotConfirmHandle={(e) => {
                this.setState({ isDeleteModalOpen: false, deleteControlPoint: null });
              }}
              text={`Удалить контрольную точку "${deleteControlPoint.title}" по адресу: ${deleteControlPoint.address}?`}
            />
          </ModalConfirmWindow>
        ) : null}
      </div>
    );
  }
}

export default withAuth(withLogisticControlPoints(React.memo(ControlPointsList)));
